import React, { Component } from "react";
import { Dropdown } from "semantic-ui-react";
import { translate } from "react-i18next";

import { connect } from "react-redux";
import { saveTeams } from "../../store/actions/AdministrationActions";
import { userFetchDataSuccess } from "../../store/actions/UserActions";
import gql from "graphql-tag";
import client from "../../store/apolloClient";

class StaffSwitcher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staffs: []
    };
  }

  componentDidMount() {
    const query = gql`
      {
        simcaa_t_staffs(order_by: { name: asc }) {
          id
          name
        }
      }
    `;

    client
      .query({ query })
      .then(staffs => this.setState({ staffs: staffs.data.simcaa_t_staffs }))
      .catch(error => console.error(error));
  }

  // Handle change staff
  changeStaff(idstaff, e) {
    this.props.refreshTeam(null, idstaff);

    let localUser = Object.assign({}, this.props.user);
    localUser.idstaff = idstaff;
    this.props.updateUser(localUser);
  }

  // MAIN RENDER
  render() {
    const { t } = this.props;
    const label =
      this.state.staffs.length > 0 &&
      this.state.staffs.filter(item => item.id === this.props.user.idstaff)[0]
        .name;

    let options = this.state.staffs.map((item, index) => {
      return (
        <Dropdown.Item
          key={index}
          onClick={this.changeStaff.bind(this, item.id)}
        >
          {item.name}
        </Dropdown.Item>
      );
    });

    return (
      <Dropdown item text={`${t("PRLD_DROP_STAFF")}: ${label}`}>
        <Dropdown.Menu>{options}</Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    refreshTeam: (user_id, staff_id) => dispatch(saveTeams(user_id, staff_id)),
    updateUser: user => dispatch(userFetchDataSuccess(user))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(StaffSwitcher));



// WEBPACK FOOTER //
// ./src/containers/switcher/StaffSwitcher.js